/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcQuestionCircleLargeRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12 7.9c-.707 0-1.323.596-1.323 1.386a.9.9 0 1 1-1.8 0C8.877 7.55 10.252 6.1 12 6.1s3.122 1.45 3.122 3.186c0 1.251-.71 2.345-1.757 2.865a1.3 1.3 0 0 0-.389.282c-.077.089-.076.133-.076.138v.54a.9.9 0 0 1-1.8 0v-.54c0-1.09.89-1.747 1.464-2.032.44-.219.758-.691.758-1.253 0-.79-.616-1.386-1.322-1.386m1.5 8.933a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
      <path
        fillRule="evenodd"
        d="M12 1.1C5.98 1.1 1.1 5.98 1.1 12S5.98 22.9 12 22.9 22.9 18.02 22.9 12 18.02 1.1 12 1.1M2.9 12a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcQuestionCircleLargeRegular;
